import './styles.scss';

// Adapter exposing the subset of the Switchery API that consumer JS
// (partial_form_switches.js, custom form handlers, etc.) relies on,
// backed by a plain native checkbox styled by the design system CSS.
class NativeToggleAdapter {
  constructor(element) {
    this.element = element;
  }

  disable() {
    this.element.disabled = true;
  }

  enable() {
    this.element.disabled = false;
  }

  // No-op: the design system toggle is driven purely by :checked.
  setPosition() {}

  isChecked() {
    return this.element.checked;
  }

  handleOnchange(value) {
    if (this.element.checked !== value) {
      this.element.checked = value;
      this.element.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  destroy() {}
}

class SmToggle {
  #item;

  init(el) {
    if (el.dataset.switchery || el.dataset.smToggleInited) return;

    if (this.#shouldUseSwitchery(el)) {
      this.#initSwitchery(el);
    } else {
      this.#initNative(el);
    }
  }

  // Switchery is used when a custom color is requested or when the partial
  // rendered in legacy mode (elements/form/_toggle puts .sm-toggle on the
  // input itself; consumer CSS/JS depends on Switchery's wrapper DOM).
  #shouldUseSwitchery(el) {
    return el.dataset.color !== undefined || el.classList.contains('sm-toggle');
  }

  #initSwitchery(el) {
    const color = el.dataset.color;
    const secondaryColor = el.dataset.secondaryColor;
    const jackColor = el.dataset.jackColor;
    const jackSecondaryColor = el.dataset.jackSecondaryColor;
    const className = el.dataset.className;
    const disabled = el.dataset.disabled !== undefined;
    const disabledOpacity = el.dataset.disabledOpacity;
    const speed = el.dataset.speed;

    this.#item = new Switchery(el, {
      size: 'small',
      color, secondaryColor, jackColor, jackSecondaryColor,
      className, disabled, disabledOpacity, speed,
    });
    el.dispatchEvent(new CustomEvent('sm-toggle:inited', { detail: { toggle: this.#item } }));
    this.#bindSetState(this.#item);
  }

  #initNative(el) {
    this.#item = new NativeToggleAdapter(el);
    el.dataset.smToggleInited = 'true';
    el.dispatchEvent(new CustomEvent('sm-toggle:inited', { detail: { toggle: this.#item } }));
    this.#bindSetState(this.#item);
  }

  #bindSetState(item) {
    item.element.addEventListener('sm-toggle:set-state', (e) => {
      const val = e.detail.value;
      if ((val && !item.isChecked()) || (!val && item.isChecked())) {
        item.setPosition(true);
        item.handleOnchange(val);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  function initToggles(wrapper = 'body') {
    document.querySelectorAll(`${wrapper} .js-sm-toggle`).forEach(el => {
      new SmToggle().init(el);
    });
  }
  initToggles();

  document.addEventListener('html-updated', e => {
    const wrapper = e.detail ? e.detail.container : undefined;
    initToggles(wrapper);
  });

  document.addEventListener('sm-modal:opened', () => {
    initToggles('.js-sm-modal');
  });

  document.addEventListener('sm-toggle:init', e => {
    const el = document.querySelector(e.detail.el);
    if (el) {
      new SmToggle().init(el);
    }
  });
});
